<template>
  <motlet :options="motletOptions">
    <template v-slot:content>
      <v-row style="flex-wrap: nowrap;" class="h-100">
        <v-col v-for="(node, index) in nodes" :key="index" class="flex-grow-1 flex-shrink-0">
          <div class="pa-auto h-100 d-flex align-center justify-center flex-column">
            <v-card @click="selectNode(index)" class="pa-2" outlined>
              <v-icon large :color="iconColor(index)">mdi-server-network</v-icon>
            </v-card>
            <div class="mt-4">{{ node.shortAlias }}</div>
          </div>
        </v-col>
      </v-row>
    </template>
  </motlet>
</template>

<script>
import instanceable from './mixins/instanceable';

export default {
  mixins: [instanceable],
  data() {
    return {
      motletOptions: {
        id: 'overview/system/java/Event',
        title: this.$t('ov.sys.title.event'),
      },
    };
  },
  methods: {
    iconColor(index) {
      // BEGIN::Modified.by.KWShin.2025.11.19.
      // return this.nodes[index].active ? 'orange darken-2' : 'grey darken-2';
      return this.nodes[index].active ? this.nodes[index].color : 'grey darken-2';
      // FINISH::Modified.by.KWShin.2025.11.19.
    },
    selectNode(index) {
      if (this.nodes[index].active) {
        const allActive = this.nodes.every(node => node.active);
        if (allActive) this.nodes.forEach((node, seq) => (node.active = index == seq));
        else this.nodes.forEach(node => (node.active = true));
      } else {
        this.nodes.forEach((node, seq) => (node.active = index == seq));
      }
    },
  },
};
</script>
